import React from "react";
import "./main-nav.scss";
import { Navbar, Container } from "react-bootstrap";
import { Link } from "react-scroll";

const MainNav = () => {
  return (
    <Navbar expand="lg" variant="light" bg="light" sticky="top">
      <Container>
        <Navbar.Brand href="/">Noches De Salsa</Navbar.Brand>
        <Navbar.Toggle aria-controls="main-nav-links" />
        <Navbar.Collapse id="main-nav-links" className="justify-content-end">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="about"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="classes"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                Classes
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="gallery"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                Gallery
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="events"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                Events
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="contact"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                activeClass="active"
                to="offers"
                spy
                smooth
                offset={-69}
                duration={500}
              >
                Offers
              </Link>
            </li>
          </ul>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNav;
